;(function($, undefined){
    var rnn,
        $stage,
        curArticleid = $('.newsEntryGlance').data('articleid'),
        cur = 0;

    function initAtAGlance() {
        if ($('.newsAtAGlance').length > 0) {
            $stage = $('.mediaStage');

            initState();

            if (atAGlanceMedia.length > 0) {

                rnn.modules.utilities.removeHash();

                var first = atAGlanceMedia[cur];

                if (first.mediaType === 'gallery') {
                    loadGallery(first);
                } else {
                    showVideoNav();
                    var $firstVideo = $stage.find('.firstVideo');
                    if (first.videoType === 'youtube') {
                        // if the first video is youtube, build the video and trash the original div, because of videoid / url issues
                        rnn.modules.videos.buildURLYoutubePlayer($stage, $firstVideo.data('videoid'), false, loadNext);
                        $firstVideo.remove();
                    } else {
                        $firstVideo.removeClass('firstVideo videoHider');
                    }
                }
            }

            var player = getPlayer();
            if (player) {
                player.on('ended', function () { loadNext(); });
                player.on('play', function () {
                    // this is to fix an edge case where the player will start playing while its hidden
                    if ($stage.find('.videoPlayer').hasClass('videoHider')) {
                        player.pause();
                    } else {
                        showVideoNav();
                    }

                });
                player.autoplay(true);
                player.on('adstart', hideVideoNav);
                player.on('adend', showVideoNav);
            }

            // If mobile display the upcoming article preview on click and loadNext on a secondary click
            if (rnn.site.isMobile === true) {
                $stage.find('.controls.next').click(function (e) {
                    e.stopPropagation();
                    if (isLast() && !$(this).hasClass('showTease')) {
                        $('.controls.prev.showTease').removeClass('showTease');
                        $(this).addClass('showTease');
                        // if we click anywhere remove the showTease class
                        $('.wrapper').one('click', function () {
                            $('.controls.next').removeClass('showTease');
                        });
                    } else {
                        $('.controls.showTease').removeClass('showTease');
                        loadNext();
                    }
                });

                $stage.find('.controls.prev').click(function (e) {
                    e.stopPropagation();
                    if (isFirst() && !$(this).hasClass('showTease')) {
                        $('.controls.next.showTease').removeClass('showTease');
                        $(this).addClass('showTease');
                        // if we click anywhere remove the showTease class
                        $('.wrapper').one('click', function () {
                            $('.controls.prev').removeClass('showTease');
                        });
                    } else {
                        $('.controls.showTease').removeClass('showTease');
                        loadNext(true);
                    }
                });

                var $carouselAction = $('.glanceCarouselAction');
                if ($carouselAction.length > 0) {
                    $carouselAction.on('click', function (e) {
                        e.preventDefault();

                        $(this)
                            .toggleClass('display')
                            .find('.tangram-icon').toggleClass('icon-arrow-down-thick').toggleClass('icon-arrow-up-thick').end()
                            .prev('.glanceCarouselHide').toggleClass('display');

                        $('.carouselControls').toggleClass('show');

                    })
                }


            } else {
                // if not mobile display the upcoming article preview on hover
                $stage.find('.controls.next').click(function () {
                    loadNext();
                }).hover(function () {
                    if (isLast()) {
                        $(this).addClass('showTease');
                    }
                }, function () {
                    $(this).removeClass('showTease');
                });
                $stage.find('.controls.prev').click(function () {
                    loadNext(true);
                }).hover(function () {
                    if (isFirst()) {
                        $(this).addClass('showTease');
                    }
                }, function () {
                    $(this).removeClass('showTease');
                });

            }

            if (rnn.site.isMobile === true) {
                // on resize check if the carousels should have controls
                $(window).resize(_.debounce(function(){
                    $('.itemCarousel').each(function () {
                        rnn.modules.carousels.checkWidth($(this), $(this).find('.item'));
                    });
                }, 500));
            }

        }
    }

    // This selects the current, grabs the data for next and prev stories and builds the next/prev teasers
    function initState() {
        var $current = $('.relatedCarousel *[data-articleid="' + curArticleid + '"]'),
            $prev = $current.prev('.item'),
            $next = $current.next('.item'),
            $prevSpace = $stage.find('.prevArticle'),
            $nextSpace = $stage.find('.nextArticle');

        $current.addClass('current');

        if ($prev.length === 0) {
            $prev = $('.relatedCarousel .item:last');
        }
        if ($next.length === 0) {
            $next = $('.relatedCarousel .item:first');
        }

        var prevData = $prev.data('articledata'),
            nextData = $next.data('articledata');

        if (prevData) {
            $prevSpace.data('url', prevData.url);
            dataToClass($prevSpace, prevData);
        }
        if (nextData) {
            dataToClass($nextSpace , nextData);
            $nextSpace.data('url', nextData.url);
        }
    }

    function dataToClass($item, data) {
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var $domElement = $item.find('.item-' + key);
                if ($domElement.length > 0) {
                    $domElement.html(data[key]);
                }
            }
        }
    }

    function showVideoNav() {
        $stage.find('.controls').show();
    }

    function hideVideoNav() {
        $stage.find('.controls').hide();
    }

    function loadVideo(item) {

        var videoId = item.videoId,
            player = getPlayer();

        $stage.find('.gallerySpace').html('').hide();
        $stage.find('.controls').show();

        if (item.videoType === 'youtube') {
            $stage.find('.videoPlayer').hide();
            if (player) {
                player.pause();
            }
             $stage.find('.youtube_video_wrapper').remove();
             showVideoNav();
             rnn.modules.videos.buildURLYoutubePlayer($stage, videoId, true, loadNext);
        } else {
            $stage.find('.videoPlayer').removeClass('videoHider firstVideo');
            $stage.find('.youtube_video_wrapper').remove();

            if (player && videoId) {
                player.catalog.getVideo(videoId, function (error, video) {
                    player.catalog.load(video);
                    player.play();
                });
            }
        }
    }

    function getPlayer() {
        var $curPlayer = $('.mediaStage').find('.video-js'),
            player = false;

        if ($curPlayer.length > 0) {
            player = videojs($curPlayer.attr('id'));
        }
        return player;
    }

    function loadGallery(item) {
        var gallerysrc = item.galleryJSON,
            player = getPlayer();
        if (gallerysrc) {
            $stage.find('.youtube_video_wrapper').remove();
            if (player) {
                player.pause();
            }
            $stage.find('.videoPlayer').addClass('videoHider');
            var $gallerySpace = $stage.find('.gallerySpace');

            $gallerySpace.html('').show();
            // The jquery selector in galleries.js needs the "data-gallery" attribute
            $gallerySpace.attr('data-gallery', 'true').data({ 'gallery': JSON.parse(gallerysrc), hidecarousel: true });
            rnn.modules.galleries.initAtAGlanceGallery();
        }
    }

    function loadNext(prev) {
        if (prev === 'undefined') prev = false;

        var nextItem,
            nextIndex;

        if (atAGlanceMedia.length > 0) {
            if (!prev) {
                nextIndex = cur+1;
            } else {
                nextIndex = cur-1;
            }

            // if theres no media elements load either the next or previous article in the carousel
            if (nextIndex === atAGlanceMedia.length || nextIndex < 0) {

                if ($('.relatedCarousel .item').length > 0) {

                    var nextArticle,
                        clickAction = 'click';
                    if (prev) {
                        nextArticle = $stage.find('.prevArticle').data('url');
                        clickAction += ' previous';
                    } else {
                        nextArticle = $stage.find('.nextArticle').data('url');
                        clickAction += ' next';
                    }
                    if (nextArticle) {
                        rnn.modules.trackEvents.track_event('Related Glance', clickAction, 'article', 0);
                        document.location.href = nextArticle;
                    }
                }
            } else {
                nextItem = atAGlanceMedia[nextIndex];
                if (nextItem) {

                    // active class is needed for mobile
                    $stage.find('.controls').removeClass('active');

                    rnn.modules.utilities.removeHash();

                    cur = nextIndex;

                    $stage.find('.controls').hide();

                    if (nextItem.mediaType === 'video') {
                        loadVideo(nextItem);
                    } else if (nextItem.mediaType === 'gallery') {
                        loadGallery(nextItem);
                    }

                }
            }
        }
    }

    function isFirst() {
        return cur === 0 ? true : false;
    }

    function isLast() {
        return atAGlanceMedia.length === 0 || (cur+1) === atAGlanceMedia.length ? true : false;
    }

    rnn = window.rnn;

    rnn.modules.register('ataglance', {
        init: initAtAGlance,
        loadNext: loadNext

    });

})(jQuery);
